export default __webpack_public_path__ + "static/media/CMC.be74eee8.png";